<div class="auth-page-wrapper pt-5">
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div class="bg-overlay"></div>

        <div class="shape">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
        </div>
    </div>

    <div class="auth-page-content">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center mt-sm-5 mb-4 text-white-50">
                        <!-- <div>
                            <a href="index.html" class="d-inline-block auth-logo">
                                <img src="assets/images/logo-light.png" alt="" height="20">
                            </a>
                        </div> -->
                        <p class="mt-3 fs-15 fw-medium" style="color: yellow;">Visitor Management System</p>
                        <p class="mt-3 fs-18 fw-bolder" style="color: yellow;">{{appservice.Company_Name}}</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card mt-4 card-bg-fill">

                        <div class="text-center mt-2">
                            <h5 class="text-primary">Please enter your valid Mobile Number</h5>
                            <!-- <p class="text-muted">Please enter your valid Mobile Number</p> -->
                        </div>
                        <div class="card-body p-4">
                            <div class="p-2 mt-4">
                                <form action="#">
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Phone No</label>
                                        <input type="text" class="form-control" name="phoneNumber" [(ngModel)]="phoneNumber" placeholder="Enter Phone No">
                                    </div>
                                    <div class="mt-4">
                                        <button class="btn btn-success w-100" (click)="sendOTP()" type="button">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>